import { useParams } from "react-router-dom";
import { useGetRemittanceBeneficiaryDetailQuery } from "../../../../store/queries/remittance";

const formatLabel = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());

const CONDITIONAL_KEYS = ["institution_name"];

const mapSectionData = (data) => {
  if (!data) return [];
  return Object.keys(data)
    .filter((key) => !CONDITIONAL_KEYS.includes(key) || data[key])
    .map((key) => ({
      label: formatLabel(key),
      value: data[key] ?? "---",
    }));
};

const useBeneficiaryDetail = () => {
  const { remittanceID } = useParams();
  const { data: beneficiaryData, isFetching } =
    useGetRemittanceBeneficiaryDetailQuery({
      remittance_id: remittanceID,
    });

  const bData = beneficiaryData?.data;

  const sections = [];

  if (bData) {
    const topLevelFields = {};
    const nestedSections = [];

    Object.keys(bData).forEach((key) => {
      if (typeof bData[key] === "object" && bData[key] !== null) {
        nestedSections.push({
          title: formatLabel(key),
          data: mapSectionData(bData[key]),
        });
      } else {
        topLevelFields[key] = bData[key];
      }
    });

    if (Object.keys(topLevelFields).length > 0) {
      sections.push({
        title: "Beneficiary Information",
        data: mapSectionData(topLevelFields),
      });
    }

    sections.push(...nestedSections);
  }

  return {
    sections,
    isFetching,
  };
};

export default useBeneficiaryDetail;
